import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = {
    companyId: null,
    recruiters: [],
    invitations: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};